export const FEEDBACK_TABLE = "feedbacks"
export const FEEDBACK_TABLE_SCHEMA =
  "id, companyId, authorUserId, status, category, syncId, updatedAt"
